import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  ButtonGroup,
  Dialog,
  InputLabel,
  List,
  ListItem,
  Paper,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  tooltipClasses,
} from "@mui/material";
import styles from "../../../styles/components/submissionUser.module.scss";
import MinimizeIcon from "../../../public/assets/icons/MinimizeIcon";
import ExpandMoreIcon from "../../../public/assets/icons/ExpandMoreIcon";
import CopyvsidIcon from "../../../public/assets/icons/CopyvsidIcon";
import { useMutation } from "react-query";
import { updateDuplicateVideoDetails } from "../../../api/functions/video.api";
import UpdateDuplicateVideoModal from "./modals/UpdateDuplicateVideoModal";

const UserMultipleVideoSubmission = ({ data, refetchVideo }) => {
  const [expanded, setExpanded] = React.useState(false);
  // const [vsidSuccess, setVsidSuccess] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [videoList, setVideoList] = useState();

  // console.warn("videoList", videoList);

  useEffect(() => {
    // console.warn("in");
    if (data.otherUploadedVideos) {
      let lists = data.otherUploadedVideos;
      let duplicates = data.duplicates;

      // console.warn("duplicates", duplicates);
      // console.warn("lists", lists);

      const a3 = lists
        .map((list) => ({
          ...list,
          ...duplicates.find((dup) => dup.match_id === list.id),
        }))
        .map((res) => ({
          ...res,
          id: res.matched ? res.match_id : res.id,
        }));

      setVideoList(a3);

      // console.warn("a3", a3);
    }
  }, [data]);

  // console.warn("data", data);

  const [openModal, setOpenModal] = useState(false);
  const [id, setId] = useState();

  const onOpen = (id) => {
    setId(id);
    setOpenModal(true);
  };
  const onClose = () => {
    setId();
    setOpenModal(false);
  };
  // console.warn('data.duplicate ', data.duplicate )

  const { mutate, isLoading } = useMutation(updateDuplicateVideoDetails, {
    onSuccess: (data) => {
      console.warn("data", data);
      refetchVideo();
      onClose();
    },
    onError: (error) => {
      console.warn("error", error);
    },
  });

  const handleUpdate = (match_id, action) => {
    mutate({ video_id: data.id, match_id, matched: action });
  };

  return (
    <div>
      <UpdateDuplicateVideoModal
        onClose={onClose}
        open={openModal}
        id={id}
        video_id={data.id}
        refetchVideo={refetchVideo}
      />

      <Box
        className={`${styles.accItems} ${styles.vsidAcc} ${
          data.status == 6 ? styles.vsidWrapperRed : styles.vsidWrapperGreen
        }`}
      >
        {/* <Box className={`${styles.vsidWrapperGreen}`}> */}
        <Accordion
          expanded={expanded === "vsid"}
          onChange={handleChange("vsid")}
        >
          <AccordionSummary
            expandIcon={
              expanded === "vsid" ? <MinimizeIcon /> : <ExpandMoreIcon />
            }
            aria-controls="vsidbh-content"
            id="vsidbh-header"
          >
            {/* {data.duplicates.length < 1 && !data.duplicate ? (
              <Typography variant="h2" className={styles.redTxt}>
                <span>
                  *Heads-up! We have received one or more submissions from this
                  user:
                </span>
              </Typography>
            ) : (
              <>
                {!data.duplicate ? (
                  <>
                    <Typography variant="h2" className={styles.greenTxt}>
                      <span>
                        This video is good to go! It doesn't match any previous
                        submissions
                      </span>
                    </Typography>
                  </>
                ) : (
                  <>
                    <Typography variant="h2" className={styles.redTxt}>
                      <span>
                        This video matches one or more previous submissions.
                      </span>
                    </Typography>
                  </>
                )}
              </>
            )} */}
            <List disablePadding className={styles.vsidBtngroup}>
              {/* <ListItem className={styles.greenBtn}>SUBID 15645</ListItem>
                  <ListItem className={styles.redBtn}>SUBID 15645</ListItem>
                  <ListItem className={styles.redBtn}>SUBID 15645</ListItem> */}

              {data.duplicates.length < 1 && data.status != 6 ? (
                <Typography variant="h2" className={styles.redTxt}>
                  <span>
                    *Heads-up! We have received one or more submissions from
                    this user:
                  </span>
                </Typography>
              ) : (
                <>
                  {data.status != 6 ? (
                    <>
                      <Typography variant="h2" className={styles.greenTxt}>
                        <span>
                          This video is good to go! It doesn't match any
                          previous submissions
                        </span>
                      </Typography>
                    </>
                  ) : (
                    <>
                      <Typography variant="h2" className={styles.redTxt}>
                        <span>
                          This video matches one or more previous submissions.
                        </span>
                      </Typography>
                    </>
                  )}
                </>
              )}
              {videoList?.map((v, i) => (
                <ListItem
                  className={
                    v.matched == "no" ? styles.greenBtn : styles.redBtn
                  }
                  key={i}
                >
                  SUBID {v.id}
                </ListItem>
              ))}
            </List>
          </AccordionSummary>

          <AccordionDetails>
            <List disablePadding className={styles.vsidmatchList}>
              {videoList?.map((v, i) => (
                <ListItem key={i}>
                  <Box className={styles.panelLeftItem}>
                    <Typography variant="body1" className={styles.titleText}>
                      {v.matched == "no"
                        ? "Submission doesn’t match"
                        : v.matched == "yes"
                        ? "Submission matches"
                        : "Does this submission match"}
                    </Typography>
                    <Button
                      endIcon={
                        <CopyvsidIcon icon={v.matched == "no" ? true : false} />
                      }
                      className={
                        v.matched == "no"
                          ? styles.greenVSIDbtn
                          : styles.btnPinkvsid
                      }
                      onClick={() => onOpen(v.id)}
                      // className={styles.greenVSIDbtn}
                    >
                      SUBID {v.id}
                    </Button>
                  </Box>
                  {data.duplicate ? null : !["no", "yes"].includes(
                      v.matched
                    ) ? (
                    <>
                      <Typography variant="body1">?</Typography>
                      <ButtonGroup>
                        <Button
                          className={styles.yesAdd}
                          onClick={() => handleUpdate(v.id, "yes")}
                        >
                          Yes
                        </Button>
                        <Button
                          className={styles.yesAdd}
                          onClick={() => handleUpdate(v.id, "no")}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </>
                  ) : null}
                </ListItem>
              ))}
            </List>
          </AccordionDetails>
        </Accordion>
      </Box>
    </div>
  );
};

export default UserMultipleVideoSubmission;
